/* eslint-disable new-cap */
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../components/button/index.tsx';
import LogoAgsafe from '../../assets/agsafebk.png';
import FirebaseContext from '../../context/firebase.context';
import 'firebase/auth';
import './login.scss';
import UsuarioContext from '../../context/usuario.context';

function Login() {
  const history = useHistory();
  const { usuario, setUsuario } = useContext(UsuarioContext);
  const {
    EfetuarLogin, loading, VerificaLogin,
  } = useContext(FirebaseContext);

  function handleChange({ target }) {
    const { name, value } = target;
    setUsuario((prevState) => ({
      ...prevState, [name]: value,
    }));
  }

  VerificaLogin();

  return (
    <div id="page-auth">
      <main>
        <div className="main-content">
          <div className="topo-login">
            <div className="frase-bem-vindo">
              <strong>
                Bem-vindo à AGSAFE.
              </strong>
            </div>
            <div>
              <img src={LogoAgsafe} alt="Agsafe" />
            </div>
          </div>
          <div className="separator">
            Informe suas credenciais de acesso
          </div>
          <form>
            <input
              type="email"
              name="email"
              value={usuario.email || ''}
              placeholder="email@email.com.br"
              onChange={(e) => handleChange(e)}
            />
            <input
              type="password"
              name="senha"
              value={usuario.senha || ''}
              placeholder="Digite a senha"
              onChange={(e) => handleChange(e)}
            />
            <Button
              disabled={loading}
              onClick={() => EfetuarLogin()}
            >
              Efetuar Login
            </Button>

            <div className="button-esqueci">
              <button
                type="button"
                className="buttons-transparent"
                alt="Esqueci minha senha"
              >
                Esqueci minha senha.
              </button>
            </div>
            <div className="button-cadastre-se">
              <button desabled className="buttons-transparent" onClick={() => history.push('/cadastro')} type="button" alt="Esqueci minha senha">
                {/* Não tem uma conta? Cadastre-se agora. */}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}

export default Login;
